import { useEffect } from "react";
import { useTranslation } from "../i18n/useTranslation";

interface TrueFalseButtonsProps {
  onAnswer: (answer: boolean) => void;
}

export function TrueFalseButtons({ onAnswer }: TrueFalseButtonsProps) {
  const { t } = useTranslation();

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const k = e.key.toLowerCase();
      if (k === "t" || k === "y" || e.key === "ArrowLeft") onAnswer(true);
      else if (k === "f" || k === "n" || e.key === "ArrowRight") onAnswer(false);
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onAnswer]);

  return (
    <div className="flex gap-3 mt-2">
      <button
        type="button"
        onClick={() => onAnswer(true)}
        className="px-8 py-3 rounded-full bg-green text-bg-1 text-base font-semibold active:scale-95 transition-transform"
      >
        {t("common.true")}
      </button>
      <button
        type="button"
        onClick={() => onAnswer(false)}
        className="px-8 py-3 rounded-full bg-red text-bg-1 text-base font-semibold active:scale-95 transition-transform"
      >
        {t("common.false")}
      </button>
    </div>
  );
}
